import React, { Component } from 'react';
import axios from 'axios'
import RequestView from './RequestView';
import ReviewCompleted from './ReviewCompleted';
import { createBrowserHistory } from 'history';
import { withRouter } from 'react-router-dom'
import Toast from 'react-bootstrap/Toast'
import ToastContainer from 'react-bootstrap/ToastContainer'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import Overlay from 'react-bootstrap/Overlay'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'

// import appSettings from '../assets/app-settings.json';

export class Review extends Component {

    state = {
        isBusy: false,
        profileDatasetsBySites: [],
        geoDatasetsBySites: [],
        userFirstName: "",
        userLastName: "",
        userEmail: "",
        userCompany: "",
        userComments: "",
        userCommentsShort: "",
        userPhoneNumber: "",
        isShowModal: false,
        isShowToast: false,
        toastTitle: "",
        toastMessage: "",
        isReviewCompleted: false,
        requestingUser: "",
        isLongComment: false
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props && this.props.requestId && !prevProps.requestId) {
            this.fetchRequestInfo();
        }
    }

    componentWillUnmount() {
        localStorage.removeItem(this.props.token);
        // fix Warning: Can't perform a React state update on an unmounted component    
        this.setState = (state, callback) => {
            return;
        };
    }


    fetchRequestInfo = () => {
        this.updateBusyState(true);
        const appSettings = window.AppConfigSettings;
        const url = appSettings.baseApiUrl + "/downloads/requests/" + this.props.requestId + "/" + this.props.token + "/" + this.props.approver;
        axios.get(url)
            .then(res => {
                const requestInfo = res.data;
                console.log(requestInfo);                

                this.setState({
                    profileDatasetsBySites: JSON.parse(requestInfo.profileDatasetPreview),
                    geoDatasetsBySites: JSON.parse(requestInfo.geoDatasetPreview),
                    userFirstName: requestInfo.userFirstName,
                    userLastName: requestInfo.userLastName,
                    userEmail: requestInfo.userEmail,
                    userCompany: requestInfo.userCompany,
                    userComments: requestInfo.userComments,
                    userCommentsShort: this.shortenUserComments(requestInfo.userComments),
                    userPhoneNumber: requestInfo.userPhoneNumber,
                    requestingUser: requestInfo.userFirstName + ' ' + requestInfo.userLastName
                });

                if (requestInfo.reviewedBy) {
                    this.setState({
                        isReviewCompleted: true
                    });
                }
            })
            .catch((error) => {
                if (error.response) {
                    // // Request made and server responded
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    if (error.response.data && error.response.data.message && error.response.data.message.startsWith("800")) {
                        this.props.history.push('/error/' + error.response.data.message);
                    } else {
                        console.log(error.response.data);
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
            })
            .finally(() => {
                this.updateBusyState(false);
            });
    }

    shortenUserComments = (comments, length) => {
        if (!length) {
            length = 50;
        }
        
        const isLongComment = comments && comments.length > length;
        this.setState({
            isLongComment: isLongComment
        });

        const newValue = comments.substring(0, length);
        return newValue;
    }

    updateBusyState = (isBusy) => {
        this.setState({
            isBusy: isBusy
        });
    }


    verifySubmitRequest = () => {
        this.setModalShow(true);
    }

    submitRequest = () => {

        const payload = {
            id: this.props.requestId,
            reviewedBy: this.props.approver,
            token: this.props.token
        }

        this.setModalShow(false);
        this.updateBusyState(true);

        setTimeout(() => {
            const appSettings = window.AppConfigSettings;
            const url = appSettings.baseApiUrl + "/downloads/requests/approve";
            axios.post(url, payload)
                .then((res) => {
                    if (res.status !== 200) {
                        // console.log(res);
                    }
                    this.setState({
                        isReviewCompleted: true
                    })
                })
                .catch((error) => {
                    console.log(error);
                    this.showErrorToast({
                        title: "Error approving request",
                        message: "An error occured while approving request. Give it some time and try approving again later."
                    });
                })
                .finally(() => {
                    this.updateBusyState(false);
                });
        }, 2000);

        // TODO: clean up localStorage after successful submission
    }

    completeReviewProcess = () => {
        this.setState({
            isReviewCompleted: true
        });

        localStorage.removeItem(this.props.token);
    }

    setModalShow = (isShow) => {
        if (!isShow) {
            isShow = false;
        }
        this.setState({
            isShowModal: isShow
        });
    }

    handleCloseToast = (event) => {
        this.setState({
            isShowToast: false
        });
    }

    showErrorToast = (error) => {
        this.setState({
            toastTitle: error.title,
            toastMessage: error.message,
            isShowToast: true
        });
    }

    render() {
        return (
            <div className="review-request">
                {this.state.isReviewCompleted ?
                    <ReviewCompleted
                        requestingUser={this.state.requestingUser}
                    ></ReviewCompleted>
                    :
                    <div>
                        <div className="review-request-header">
                            <h3>Approve Request</h3>
                        </div>
                        {this.state.isBusy ?
                            <div className="request-busy-indicator">
                                <Spinner
                                    as="div"
                                    animation="grow"
                                    size="lg"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Working...
                            </div>
                            : null
                        }
                        <div className="review-request-details">
                            <h5>Request By</h5>
                            <div> <span>Name:</span> {this.state.userFirstName} {this.state.userLastName}</div>
                            <div> <span>Email:</span> {this.state.userEmail} </div>
                            <div> <span>Phone Number:</span> {this.state.userPhoneNumber} </div>
                            <div> <span>Organization:</span> {this.state.userCompany} </div>
                            <div> <span>Purpose of Data Request:</span> {this.state.userCommentsShort}
                                {
                                    this.state.isLongComment ?
                                        <span className="full-comments-span">...
                                            <OverlayTrigger
                                                trigger="click"
                                                placement='bottom'
                                                overlay={
                                                    <Popover id={`popover-positioned-bottom`}>
                                                        <Popover.Body>
                                                            {this.state.userComments}
                                                        </Popover.Body>
                                                    </Popover>
                                                }
                                            >
                                                <button className="full-comments-more-button">more &raquo;
                                                </button>
                                            </OverlayTrigger>
                                        </span>
                                        :
                                        null
                                }
                            </div>

                            <button
                                onClick={this.verifySubmitRequest}
                            ><i className="fas fa-paper-plane"></i>Approve Request
                            </button>

                        </div>
                        <div className="review-request-view">
                            <RequestView
                                profileDatasetsBySites={this.state.profileDatasetsBySites}
                                geoDatasetsBySites={this.state.geoDatasetsBySites}
                            ></RequestView>
                        </div>
                    </div>
                }
                <ToastContainer className="p-3" position='top-center'>
                    <Toast show={this.state.isShowToast} delay={8000} autohide bg="danger" onClose={this.handleCloseToast}>
                        <Toast.Header>
                            <strong className="me-auto">{this.state.toastTitle}</strong>
                            {/* <small className="text-muted">2 seconds ago</small> */}
                        </Toast.Header>
                        <Toast.Body>
                            {this.state.toastMessage}
                        </Toast.Body>
                    </Toast>
                </ToastContainer>

                <Modal
                    show={this.state.isShowModal}
                    onHide={this.setModalShow}
                    backdrop="static"
                    keyboard={false}
                    centered
                    aria-labelledby="contained-modal-title-vcenter">
                    <Modal.Header closeButton>
                        <Modal.Title>Approval Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Please confirm that you have carefully reviewed this request and wish to approve now. </p>
                    </Modal.Body>
                    <Modal.Footer>

                        <button
                            onClick={() => this.setModalShow(false)}
                        ><i className="fas fa-times"></i>Cancel
                        </button>
                        <button className="button-submit"
                            onClick={this.submitRequest}
                        ><i className="fas fa-paper-plane"></i>Approve
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default withRouter(Review)
